module.exports = __webpack_public_path__ + "static/media/fedpa-street-selected.920fb399.svg";